import { gql } from '@apollo/client'
import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { Order, StateTransitionArgs } from '@ztechapps/common.contract'
import { orderFragment } from './graphql'

export const changeOrderStatusQuery = gql`
  ${orderFragment}
  mutation changeOrderStatus($input: StateTransitionArgs!) {
    changeOrderStatus(input: $input) {
      ...orderFragment
    }
  }
`

export const useChangeOrderStatus = (args?: Omit<UseMutationProps, 'query'>) => {
  return useMutation<{ changeOrderStatus: Order }, StateTransitionArgs<Order>>({
    query: changeOrderStatusQuery,
    ...args,
  })
}
